module.exports = __webpack_public_path__ + "img/C04TechPaidLabor_ua.d573d129.webp";